import React from 'react'
import { BaseCheckbox } from './base-checkbox'

export const TriStateCheckboxValues = {
  CHECKED: 'true',
  UNCHECKED: 'false',
  MIXED: 'mixed',
} as const

export type TriStateCheckboxValue =
  typeof TriStateCheckboxValues[keyof typeof TriStateCheckboxValues]
export interface TriStateCheckboxProps {
  value?: TriStateCheckboxValue
  disabled?: boolean
  label?: string | React.ReactNode
  onChange: (newValue: TriStateCheckboxValue) => void
}

export const TriStateCheckbox = ({
  disabled = false,
  onChange,
  value = 'false',
  ...props
}: TriStateCheckboxProps) => {
  const handleValueChange = () => {
    if (value === TriStateCheckboxValues.CHECKED) {
      onChange(TriStateCheckboxValues.UNCHECKED)
    } else {
      onChange(TriStateCheckboxValues.CHECKED)
    }
  }

  return (
    <BaseCheckbox
      {...props}
      disabled={disabled}
      value={value}
      onClick={() => !disabled && handleValueChange()}
    />
  )
}
